import { Button, Spinner, type ButtonProps } from "react-bootstrap";

interface LoaderButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

export default function LoaderButton({
  children,
  loading = false,
  loadingText,
  disabled,
  ...rest
}: LoaderButtonProps) {
  return (
    <Button disabled={disabled || loading} {...rest}>
      {loading ? (
        <span className="d-flex align-items-center justify-content-center gap-2">
          <span>{loadingText || children}</span>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          <span className="visually-hidden">Loading...</span>
        </span>
      ) : (
        children
      )}
    </Button>
  );
}
